'use client';

import { usePathname } from 'next/navigation';
import MicroBannerBlock from '~/components/legos/Blocks/MicroBannerBlock';
import { RailsPageView } from '~/typings/services/rails/tile';

const ignoredRoutes = /^\/(shop|gear|sell-now|locker|settings|checkout)(\/.*)?/;

export default function AppDirMicroBanner({
  pageView,
}: {
  pageView: RailsPageView;
}) {
  const pathname = usePathname();
  const microbanner = pageView.blocks?.find(
    block => block.layout === 'micro-banner',
  );

  if (!microbanner || ignoredRoutes.test(pathname || '')) {
    return null;
  }

  return <MicroBannerBlock block={microbanner} pageView={pageView} />;
}
